import React from "react"
import { Link } from "gatsby"

const Layout = ({ location, title, children }) => {

  return (
    <>
      <main>
        {children}
      </main>
      <footer>
        <nav>
          <Link to="/">lenvingonsalves.com</Link> 
        </nav>
       </footer>
    </>
  )
}

export default Layout
